import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import axios from 'axios';
import config from './config/config';
import {BrowserRouter, Route} from "react-router-dom";

axios.defaults.baseURL = config["back-end-server"]["back-end-host"] + config['back-end-server']['url-prefix'];

ReactDOM.render(<BrowserRouter>
                    <Route path={`/webapp/:hash`} component={App} />
                </BrowserRouter>, document.getElementById('root'));

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
    })
}